export default {
    'profile': 'Mein Profil',
    'changeLanguage': 'Sprache ändern',
    'addDeliveryOrder': 'Neue Lieferung erfassen'
}